import bootbox from 'bootbox'
import $ from 'jquery'
import { getOptions, getQuantity } from '@/catalog/product-options'
import loading from '@/loading'
import {
  trackClickedRequestProductQuoteButton,
  trackFinishedAddToCart,
  trackStartedAddToCart,
  trackViewedRequestProductQuoteModal
} from '@/services/analytics'
import {
  getAnalyticsTrackingProperties,
  getRequestProductQuoteProperties
} from '@/catalog/product-analytics'
import { update } from '@/services/cart'
import { goToCartPage } from '@/utils/cartTransitionUtils'
import { AuthenticationAborted } from '@/api/error'
import _ from 'underscore'
import { PersonalizeInitOptions } from '@/Personalize/types'
import { createProductQuoteTicketUrl } from '@/zendeskPrefilledTicket/zendeskTicketPrefiller'
import { type Item as ItemAttributes } from '@/api/items'
import { ProductPageItem } from '@/globals'

export const showRequestProductQuoteModal = (
  item: ItemAttributes | ProductPageItem
) => {
  trackViewedRequestProductQuoteModal(getRequestProductQuoteProperties(item))
  bootbox.dialog({
    closeButton: false,
    onEscape: true,
    message: 'For large orders, please request a personalized quote.',
    buttons: {
      Back: {},
      'Get quote': () => {
        trackClickedRequestProductQuoteButton(
          getRequestProductQuoteProperties(item)
        )
        window.open(
          createProductQuoteTicketUrl({
            itemShortTitle: item.shortTitle,
            itemUrl: window.location.origin + item.seoPath
          }),
          '_blank'
        )
      }
    }
  })
}

const handleAddToCartClick = async (e: JQuery.ClickEvent) => {
  try {
    e.preventDefault()
    if (getQuantity() === -1) {
      return showRequestProductQuoteModal(window.item!)
    }
    loading.show()

    trackStartedAddToCart(getAnalyticsTrackingProperties())

    const itemId = $(e.currentTarget).data('itemid')
    await update({
      itemId,
      quantity: getQuantity(),
      _incrementQuantity: true
    })
    await trackFinishedAddToCart(getAnalyticsTrackingProperties())
    goToCartPage()
  } catch (error) {
    if (!(error instanceof AuthenticationAborted)) {
      bootbox.alert(
        'There was an error adding the item to your cart. Please try again.'
      )
    }
  }
}

const handlePersonalizeClick = (e: JQuery.ClickEvent) => {
  const personalizePath = $(e.currentTarget).attr('href')
  if (personalizePath?.substring(0, 16) === '/eco/personalize') {
    e.preventDefault()

    const { trimEnumName, ...partialOptions } = _.omit(
      getOptions(),
      'trim',
      'trimPrinterCode',
      'thickness'
    )
    const options: PersonalizeInitOptions = {
      ...partialOptions,
      // Rename trimEnumName to trim.
      // Personalization's option param names don't contain enum name (it's implicit).
      trim: trimEnumName,
      cameFromProductPage: true,
      // If we have additional items to add to the cart *after* personalization, specify them here.
      // Simply an array of objects with properties 'itemId' and 'quantity'
      // `additionalItemsFirst` is just a hack to add certain additional-items to the cart before other additional items.
      // We add invitations to the cart first.
      additionalItemsFirst: [],
      additionalItems: []
    }

    if (options.quantity === -1) {
      return showRequestProductQuoteModal(window.item!)
    }

    $('.matching-items .addtocart-quantity').each(function () {
      const $select = $(this)
      const subtype = $select.data('subtype')
      const itemToAdd = {
        itemId: $select.data('itemid'),
        quantity: parseInt($select.val() as string)
      }
      if (itemToAdd.quantity > 0) {
        if (subtype === 'Invitations') {
          options.additionalItemsFirst!.push(itemToAdd)
        } else {
          options.additionalItems!.push(itemToAdd)
        }
      }
    })

    loading.show()
    window.location.href =
      personalizePath +
      '/options/' +
      encodeURIComponent(JSON.stringify(options))
  }
}

export const initializeCtaButtons = () => {
  $('#addtocart-big').on('click', handleAddToCartClick)
  $('.personalize-big').on('click', handlePersonalizeClick)
}
